import { render, staticRenderFns } from "./ScoreboardContent.vue?vue&type=template&id=6eec4338&scoped=true"
import script from "./ScoreboardContent.vue?vue&type=script&lang=js"
export * from "./ScoreboardContent.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardContent.vue?vue&type=style&index=0&id=6eec4338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec4338",
  null
  
)

export default component.exports